import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "@reach/router";
import CardItem from "./../HomeScreen/CardHome";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Filter1Icon from "@material-ui/icons/Filter1";
import Filter2Icon from "@material-ui/icons/Filter2";
import Filter3Icon from "@material-ui/icons/Filter3";

const styles = (theme) => ({
  sizeIconCard: {
    fontSize: 40,
    fill: "#3f51b5",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    color: theme.palette.text.secondary,
  },
  grid: {
    justifyContent: "center",
  },
});

export const ScreenHome = (props) => {
  const { classes } = props;

  const menu = [
    {
      icon: <Filter1Icon className={classes.sizeIconCard} />,
      text: "Cheques a descontar",
      path: "/relatorio/cheques-a-descontar",
    },
    {
      icon: <Filter2Icon className={classes.sizeIconCard} />,
      text: "Pesquisa de cheques",
      path: "/relatorio/pesquisa-cheque",
    },

    {
      icon: <Filter3Icon className={classes.sizeIconCard} />,
      text: "Relatorios de operações",
      path: "/relatorio/operacoes",
    },
  ];
  return (
    <Grid className={classes.grid} container>
      {menu.map((item, index) => {
        return (
          <Grid
            style={{ display: "flex", flexDirection: "column" }}
            item
            key={index}
          >
            <Link to={item.path} style={{ textDecoration: "none" }}>
              <Paper
                component={() => (
                  <CardItem name={item.text} Icon={() => item.icon} />
                )}
                className={classes.paper}
              />
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
};

ScreenHome.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScreenHome);
